<template>
    <form>
      <div class="category-top-bar" ref="optionsTopBar">
        <div class="top-bar">
        <p>
            <a class="btn btn-orange btn-icon back" :title="$t('general.back')" @click.prevent="goBack">
              <i class="ti-arrow-left"></i>
              {{ $t('general.back') }}
            </a>
        </p>
        <p class="d-inline-flex">
            <a class="btn btn-danger btn-icon btn btn mar-rt-10 delete" v-if="!isNew()" @click.prevent="handleDelete('delete')" style="padding: 7px 10px; margin-right: 20px;margin-bottom: 0;">
              <img src="/static/img/icons/icon-close.png">
              {{$t('general.delete')}}
            </a>
            <a class="btn btn-danger btn-icon btn btn mar-rt-10 delete" v-if="isNew()" @click.prevent="handleDelete('cancel')" style="padding: 7px 10px; margin-right: 20px;margin-bottom: 0;">
              <img src="/static/img/icons/icon-close.png">
              {{$t('general.cancel')}}
            </a>
            <button type="submit" class="btn btn-icon btn-success mar-rt-10 save" style="margin-bottom: 0;"  @click.prevent="validate" :title="$t('general.save')">
              <img src="/static/img/icons/save.png">
              {{$t('general.save')}}
            </button>
          </p>
        </div>
      </div>
      <div class="card mar-to-15">
        <div :class="(loading ? 'show-loader' : 'hide-loader')">
          <div class="el-loading-spinner">
            <svg viewBox="25 25 50 50" class="circular">
              <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
            </svg>
          </div>
        </div>
        <div class="card-content">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>{{$t('infoPages.title')}}</label>
                <input type="text"  class="form-control"
                  name="title"
                  :placeholder="$t('infoPages.title')"
                  v-model="model.title"
                  v-validate="modelValidations.title"
                />
              </div>
              <small class="text-danger" v-if="errors.has('title')">
                {{ getError('title') }}
              </small>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <div>
                  <label class="pad-to-10">{{$t('settingsInfoPages.content')}}</label>
                  <wysiwyg rows="15"
                    name="description"
                    style="height:500px; height: calc(100% - 32px);"
                    :placeholder="$t('infoPages.shortDescription')"
                    v-model="model.description"
                    class="form-control"
                    @change="validateEditor"
                    :aria-invalid="errors.has('description')"
                  />
                  <small class="help-block">
                    {{$t('infoPages.changeLinkTab')}}
                  </small>
                  <small class="text-danger" v-if="errors.has('description')">
                    {{ getError('description') }}
                  </small>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label>{{ $t('catalogProd.image') }}</label>
                <el-upload
                  action=""
                  ref="upload"
                  :limit="2"
                  :file-list="[{'url': this.model.image}]"
                  list-type="picture-card"
                  accept=" .jpg, .jpeg, .png"
                  :on-change="handleImgChnage"
                  :on-exceed="handleExceed"
                  :on-remove="handleRemove"
                  :auto-upload="false">
                  <img src="/static/img/icons/icon-plus-primary.png">
                  <div class="el-upload__tip" slot="tip">{{$t('validations.pictureSize')}}</div>
                </el-upload>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label>{{ $t('settingsInfoPages.imageSize') }}</label>
                <br/>
                <el-select
                  v-model="model.image_size"
                  clearable
                  name="image_size"
                  :placeholder="$t('general.select')">
                  <el-option
                    v-for="size in imageSizes"
                    :key="size.value"
                    :label="size.label"
                    :value="size.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <p-checkbox v-model="model.show_in_header">
                  {{$t('settingsInfoPages.showInHeader')}}
                </p-checkbox>
                <p-checkbox v-model="model.show_in_footer">
                  {{$t('settingsInfoPages.showInFooter')}}
                </p-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>

    </form>
</template>
<script>
  import Vue from 'vue'
  import {mapFields} from 'vee-validate'
  import {Input, Button, Select, Option} from 'element-ui'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  import 'vue-wysiwyg/dist/vueWysiwyg.css'

  Vue.use(Button)
  Vue.use(Input)
  Vue.use(Select)
  Vue.use(Option)

  export default {
    components: {
      [Button.name]: Button,
      [Input.name]: Input,
      [Select.name]: Select,
      [Option.name]: Option
    },
    computed: {
      ...mapFields(['title', 'description', 'sort_order', 'image']),
      imageSizes () {
        return [
          { value: 'contain', label: this.$t('settingsInfoPages.imageSizeContain') },
          { value: 'cover', label: this.$t('settingsInfoPages.imageSizeCover') },
          { value: 'full_page', label: this.$t('settingsInfoPages.imageSizeFullPage') }
        ]
      }
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        model: {
          show_in_header: false,
          show_in_footer: false,
          image_size: null
        },
        modelValidations: {
          title: {
            required: true,
            min: 5
          }
        },
        loading: true,
        imagelist: []
      }
    },
    created: function () {
      this.$nextTick(function () {
        this.loading = true
      })
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }
      if (this.route.params.id) {
        var id = this.route.params.id
        this.apiRequest('/settings/infopages/' + id, 'GET', data, (response) => {
          if (response.status === true) {
            this.model = response.data[0]
            this.$nextTick(() => { this.loading = false })
          } else {
            this.$nextTick(() => { this.loading = false })
          }
        })
      }
      this.$nextTick(() => { this.loading = false })
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        let isEditorValid = this.validateEditor()

        if (!isEditorValid) {
          return false
        }

        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.errors.clear()
            this.savePage()
          }
        })
      },
      validateEditor () {
        if (this.errors.items.length) {
          this.errors.items = this.errors.items.filter(item => item.field !== 'description')
        }

        if (!this.model.description || this.model.description.length <= 5) {
          this.errors.add('description', 'Field is required. Min length: 5')

          return false
        }

        return true
      },
      handleErrors (errors) {
        for (var prop in errors) {
          if (errors.hasOwnProperty(prop)) {
            this.errors.add(prop, errors[prop])
          }
        }
      },
      isNew () {
        if (this.route.params.id) {
          return false
        } else {
          return true
        }
      },
      handleDelete (label) {
        swal({
          text: this.$t('infoPages.areYouSure', {label: this.$t('infoPages.' + label)}),
          type: 'question',
          showCancelButton: true,
          cancelButtonText: this.$t('general.cancel'),
          confirmButtonText: this.$t('general.yes')
        })
        .then((result) => {
          if (result) {
            if (this.isNew()) {
              // this.router.push('/custom-info-pages')
              this.$bus.$emit('refresh')
              this.$bus.$emit('close-modal')
            } else {
              var id = this.route.params.id
              var data = {
                id: id,
                token: this.$session.get('token'),
                company_id: this.$session.get('selectedCompany')
              }
              this.apiRequest('/settings/infopages/' + id, 'DELETE', data, (response) => {
                if (response.status === true) {
                  swal({
                    text: this.$t('infoPages.deleted'),
                    type: 'success',
                    showConfirmButton: false,
                    timer: 1500
                  })
                  // this.router.push('/custom-info-pages')
                  this.$bus.$emit('refresh')
                  this.$bus.$emit('close-modal')
                } else {
                  swal(
                    '',
                    response.errors['id'] ? response.errors['id'] : this.$t('validations.wentWrong'),
                    'error'
                  )
                }
              })
            }
          }
        })
      },
      handleImgChnage (file, fileList) {
        const isOkSize = file.size / 1024 / 1024 < 5
        var self = this
        if (!isOkSize) {
          swal({
            toast: true,
            type: 'warning',
            text: self.$t('validations.pictureSizeExceed'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          }).then(() => {})
          .catch(() => {})
          this.$refs.upload.clearFiles()
          this.imagelist = []
        } else {
          if (fileList.length > 1) {
            this.imagelist = fileList.slice(1)
          } else {
            this.imagelist = fileList
          }
        }
        if (this.imagelist && this.imagelist[0].status === 'ready') {
          this.getBase64(this.imagelist[0].raw).then(
            (base64enc) => {
              this.model.image = base64enc
            }
          )
        }
      },
      handleRemove (file, fileList) {
        if (fileList.length === 0) {
          this.imagelist = []
          this.model.image = null
        }
      },
      uploadImage (upload) {
      },
      handleExceed (files, fileList) {
        swal({
          text: 'Please remove the current file in order to be able to add a new one',
          type: 'warning',
          showConfirmButton: true
        })
      },
      beforeUpload (file) {
        const isOkSize = file.size / 1024 / 1024 < 5
        var self = this
        if (!isOkSize) {
          swal({
            toast: true,
            type: 'warning',
            title: self.$t('validations.pictureSizeExceed'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          }).then(() => {})
          .catch(() => {})
        }
        return isOkSize
      },
      savePage () {
        this.loading = true
        var data = this.model
        data.token = this.$session.get('token')
        data.company_id = this.$session.get('selectedCompany')
        data.type = 'CUSTOM'
        if (this.isNew()) {
          this.apiRequest('/settings/infopages', 'POST', data, (response) => {
            if (response.status === true) {
              this.$nextTick(() => { this.loading = false })
              swal(
                {
                  title: '',
                  text: this.$t('infoPages.added'),
                  type: 'success',
                  showConfirmButton: false,
                  timer: 1500
                }
              ).catch(() => {})
              // this.router.push('/custom-info-pages')
              this.$bus.$emit('refresh')
              this.$bus.$emit('close-modal')
            } else {
              this.$nextTick(() => { this.loading = false })
              swal(
                {
                  title: '',
                  text: this.$t('catalogCateg.couldNotSave'),
                  type: 'error',
                  showConfirmButton: false,
                  timer: 1500
                }
              ).catch(() => {})
              this.$nextTick(() => { this.loading = false })
              // this.router.push('/custom-info-pages')
              this.$bus.$emit('refresh')
              this.$bus.$emit('close-modal')
            }
          })
        } else {
          var self = this
          var id = this.route.params.id
          this.apiRequest('/settings/infopages/' + id, 'PUT', data, (response) => {
            if (response.status === true) {
              self.$nextTick(function () { self.loading = false })
              swal(
                {
                  title: '',
                  text: self.$t('infoPages.updated'),
                  type: 'success',
                  showConfirmButton: false,
                  timer: 1500
                }
              )
              .then(() => {})
              .catch(() => {}) // end swal
              // this.router.push('/custom-info-pages')
              this.$bus.$emit('refresh')
              this.$bus.$emit('close-modal')
              if (typeof self.callback === 'function') {
                self.callback()
              }
            } else {
              self.$nextTick(function () { self.loading = false })
              swal(
                {
                  title: '',
                  text: self.$t('catalogCateg.couldNotUpdate'),
                  type: 'danger',
                  showConfirmButton: false,
                  timer: 1500
                }
              )
              .then(() => {})
              .catch(() => {}) // end
              this.$nextTick(() => { this.loading = false })
              // this.router.push('/custom-info-pages')
              this.$bus.$emit('refresh')
              this.$bus.$emit('close-modal')
            }
          })
        }
      },
      goBack () {
        // this.router.push('/product-options')
        this.$bus.$emit('refresh')
        this.$bus.$emit('close-modal')
      }
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/InfoPagesCustom/CustomInfoPageForm.vue